import api from '../../utils/axios';

export default {
  namespaced: true,
  
  state: {
    softwareVersions: [],
    currentVersion: null,
    loading: false,
    error: null
  },
  
  mutations: {
    SET_SOFTWARE_VERSIONS(state, versions) {
      state.softwareVersions = versions;
    },
    SET_CURRENT_VERSION(state, version) {
      state.currentVersion = version;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  
  actions: {
    // 获取所有软件版本
    async fetchSoftwareVersions({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/downloads/versions');
        commit('SET_SOFTWARE_VERSIONS', response);
        // 如果有版本，设置最新版本为当前版本
        if (response.length > 0) {
          commit('SET_CURRENT_VERSION', response[0]);
        }
        return response;
      } catch (error) {
        commit('SET_ERROR', error.message || '获取软件版本列表失败');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 获取特定版本的软件信息
    async fetchSoftwareVersionById({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/downloads/versions/${id}`);
        return response;
      } catch (error) {
        commit('SET_ERROR', error.message || '获取软件版本信息失败');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 下载软件
    async downloadSoftware(_, { id, version }) {
      try {
        // 获取下载链接
        const response = await api.get(`/downloads/versions/${id}`);
        if (response && response.download_link) {
          // 使用浏览器下载文件
          window.location.href = response.download_link;
          return true;
        }
        return false;
      } catch (error) {
        console.error('下载软件失败:', error);
        throw error;
      }
    }
  },
  
  getters: {
    allVersions: state => state.softwareVersions,
    latestVersion: state => state.currentVersion,
    isLoading: state => state.loading,
    error: state => state.error
  }
}; 